import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import FixedHeightComps from "../../utils/fixedHeightComps";
import "./style.less";

const screenHeight = typeof window !== "undefined" && window.innerHeight

class PipelineTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabItemComponent: [],
      selected: 0,
      tabFixed: false,
      tabChName: '',
      selectRecord: [0],  // 记录被点击过的Tab索引，未被记录的，对应Tab下的内容不加载
      reRender: false,
      isAndroid: utils.isAndroid()
    };
    this.isIframe = utils.getParams('isIframe') == 1;
    this.pipelineTabRef = null;
    this.tabItemRef = null;
    this.tabItemContentRef = null;
    this.tabItemPlaceholderRef = null;
    this.initSet = false;
    // 滚动事件监听
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll',(e)=>{
        this.onScroll();
      });
    }
  }

  componentDidMount() {
    const { useTabContainerBgColor } = this.props.config.baseConfig;
    useTabContainerBgColor && this.modifyPageBackgroundColor();

    if (typeof window !== 'undefined' && window.parent && this.isIframe) {
      // 在iframe中打开，获取组件尺寸并发送后台编辑器
      utils.postComponentSizeToEditor();
    }
  }
  // 修改页面背景色
  modifyPageBackgroundColor = () => {
    const { grains } = this.props.config.containerConfig;
    if (grains && grains.length > 0) {
      const tabContainerBgColor = grains[this.state.selected].tabTitle.tabContainerBgColor;
      if (tabContainerBgColor) {
        document.querySelector('html').style.backgroundColor = tabContainerBgColor;
        document.querySelector('body').style.backgroundColor = tabContainerBgColor;
      }
    }
  }
  handleTabSelect = (event, item, index) => {
    event.preventDefault();
    if (index === this.state.selected) {
      return;
    }
    const { selectRecord = [0] } = this.state;
    const hasRecord = selectRecord.findIndex(item => item === index)
    const navigationBarHeight = this.props.navigationBarHeight;
    const { tabFixed } = this.state;
    const newProps = JSON.parse(JSON.stringify(this.props));
    let tabBarOffsetTop = 0;
    if (tabFixed) {
      tabBarOffsetTop = this.tabItemPlaceholderRef && this.tabItemPlaceholderRef.offsetTop;
    } else {
      tabBarOffsetTop = this.tabItemRef && this.tabItemRef.offsetTop;
    }
    Object.assign(newProps, {
      tabChName: item.tabTitle.tabName
    });
    utils.uploadTrack(newProps, {
      sort: index
    });
    if (hasRecord < 0) {
      selectRecord.push(index)
    }
    this.setState({
      selected: index,
      selectRecord,
      tabChName: item.tabTitle.tabName,
      reRender: true
    }, () => {
      tabFixed && tabBarOffsetTop > 0 && window.scrollTo(0, tabBarOffsetTop - navigationBarHeight + 1);
      this.updateNavPostion();
    });
  }

  onScroll = () => {
    const navigationBarHeight = this.props.navigationBarHeight;
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    const navOffsetTop = this.pipelineTabRef ? (this.pipelineTabRef.offsetTop - navigationBarHeight) : 0;
    const tabItem = this.tabItemRef;
    const tabItemContent = this.tabItemContentRef;
    const tabItemClientHeight = tabItem ? tabItem.clientHeight : 0;
    const bottomOffsetTop = tabItemContent ? (tabItemContent.offsetTop + tabItemContent.clientHeight) : 0;

    if (scrollHeight - navOffsetTop > 0 && scrollHeight < bottomOffsetTop - navigationBarHeight - tabItemClientHeight) {
      !this.state.tabFixed && this.setState({
        tabFixed: true,
        reRender: true
      });
    } else {
      this.state.tabFixed && this.setState({
        tabFixed: false,
        reRender: true
      });
    }

    // this.setNavigationBarHeight();
  }

  setNavigationBarHeight = () => {
    if (this.initSet) {
      return;
    }
    const allComponents = this.props.allComponents || [];
    const componentId = this.props['customAttributes'] ? this.props['customAttributes']['data-component-id'] : '';
    const componentIdx = allComponents.findIndex(item => item && item.id === componentId);
    const pipelineNavigationIdx = allComponents.findIndex(item => item && item.name === 'pipeline-navigation');
    const setHeight = () => {
      const navigationBar = document.querySelector('.navigation-bar-wrapper');
      if (navigationBar && this.tabItemRef) {
        window.navigationBarHeight = navigationBar.clientHeight + this.tabItemRef.clientHeight - 1.5;
        this.initSet = true;
      }
    }
    if (pipelineNavigationIdx >= 0) {
      if (componentIdx < pipelineNavigationIdx) {
        setHeight();
      } else {
        this.initSet = true;
      }
    } else {
      setHeight();
    }
  }

  updateNavPostion = () => {
    // 导航条切换选中后，调整当前导航到居中位置
    const navigationBar = document.querySelector('.tab-scroll');
    const checkedNavItem = document.querySelector(`.tab-item-nav-active`); // 当前选中的导航item
    const navWidth = navigationBar.offsetWidth; // 导航栏宽度
    const checkedItemOffsetLeft = checkedNavItem.offsetLeft; // 元素距离左边距离
    const checkedItemWidth = checkedNavItem.offsetWidth;
    // 需要滚动的距离
    const shouldUpdateScroll = checkedItemOffsetLeft - (navWidth / 2 - checkedItemWidth / 2) - 16;
    if (navigationBar.scrollWidth > navWidth) {
      // 如果导航条可以滚动，执行滚动操作
      navigationBar.scroll({
        top: 0,
        left: shouldUpdateScroll,
        behavior: 'smooth',
      });
      // 顶部固定导航条也执行滚动操作
      document.querySelector('.tab-scroll').scroll({
        top: 0,
        left: shouldUpdateScroll,
        behavior: 'smooth',
      });
    }
  }

  render() {
    const { osVersion = '', legoAb = '' } = this.props;
    const { isAndroid, selected, tabFixed, selectRecord = [0], reRender } = this.state;
    const { moduleMarginTop, tabType, fontColor } = this.props.config.baseConfig;
    const { grains } = this.props.config.containerConfig;
    if (!grains || grains.length <= 0) {
      return null;
    }

    const navList = [];
    const pipelineTabItem = this.props.allComponents.filter(item => item.name === 'pipeline-tabItem');
    const pipelineFilterTabItem = this.props.allComponents.filter(item => item.name !== 'pipeline-tabItem');
    const findIndexPipelineTab = pipelineFilterTabItem.findIndex(item => item.name === 'pipeline-tab');
    let tabBarHeight = 0;
    let tabItemComponent = [];

    if (this.tabItemRef) {
      tabBarHeight = this.tabItemRef.clientHeight;
    }

    for (const [tabIndex, tabItem] of pipelineTabItem.entries()) {
      tabItem.data.forEach((item, index) => {
        if (item.name == 'pipeline-ab') {
          if (!legoAb || typeof window == 'undefined') {
            // 将组件名置空，不进行渲染
            item.name = ''
            return
          }
          const list = item.data || []
          list.forEach(comp => {
            if (comp.id.endsWith(`TEST_${legoAb}`)) {
              tabItem.data[index] = comp
              item = comp
            }
          })
        }
      });
      const Components = tabItem.data.map((oneComponent, index) => {
        if (
          ([
            'pipeline-product',
            'pipeline-goodsRecommend',
            'pipeline-rank',
            'pipeline-imgHotMap',
            'pipeline-community',
            'pipeline-communityArticle',
            'pipeline-pkRank',
            'pipeline-product-customize',
            'pipeline-productCollection',
            'pipeline-productGather',
            'pipeline-productLayout3'
          ].includes(oneComponent.name)) &&
            oneComponent.data &&
            oneComponent.data.baseConfig &&
            oneComponent.data.baseConfig.addToNav &&
            oneComponent.data.baseConfig.title &&
            navList.indexOf(oneComponent.data.baseConfig.title) === -1
        ) {
          navList.push({
            id: oneComponent.id,
            title: oneComponent.data.baseConfig.title
          });
        }
        if (oneComponent.name === 'pipeline-imgList' &&
          oneComponent.data &&
          oneComponent.data.baseConfig &&
          oneComponent.data.baseConfig.addToNav &&
          oneComponent.data.baseConfig.title
        ) {
          navList.push({
            id: oneComponent.id,
            title: oneComponent.data.baseConfig.title
          });
        }

        // 给Tab子组件添加blockName
        if (oneComponent.name && oneComponent.id && !oneComponent.blockName) {
          oneComponent.blockName = oneComponent.id
          let json = null
          try {
            json = require(`comp/${oneComponent.name}/package.json`)
          } catch (e) {
            console.log('not found')
          }
          if (json && json.pipeline) {
            oneComponent.blockName += `-${json.pipeline.title}`
            if (oneComponent.data && oneComponent.data.baseConfig && oneComponent.data.baseConfig.title) {
              oneComponent.blockName += `_${oneComponent.data.baseConfig.title}`
            }
          }
        }

        const otherProps = {
          isLastComponent: index === tabItem.data.length - 1,
          osVersion: this.props.osVersion,
          showCompMarginBottom: this.props.showCompMarginBottom
        }

        // 渲染Tab子组件
        const OneComponent = this.props.baseAllComponents[oneComponent.name];

        const { componentSize } = oneComponent.data;
        const containerStyle = {};
        if (componentSize && componentSize.height !== "" && FixedHeightComps.indexOf(oneComponent.name) >= 0 && !this.isIframe) {
          Object.assign(containerStyle, {
            minHeight: oneComponent.name != 'pipeline-navigation' ? px2rem(`${componentSize.height}px`) : px2rem('40px')
          })
        }

        return OneComponent && (
          <div className="component-wrapper" style={{...containerStyle}} key={`OneComponent-${index}`}>
            <OneComponent
              componentIndex={index}
              componentLength={tabItem.data.length}
              key={oneComponent.id}
              from={this.props.from}
              downloadUrl={this.props.downloadUrl}
              kouling={this.props.kouling}
              navList={navList}
              hasNavigation={this.props.hasNavigation}
              customAttributes={{
                "data-component-id": oneComponent.id,
                "data-component-name": oneComponent.name,
                "data-component-block": oneComponent.blockName,
                "data-component-belong": "tab"
              }}
              config={oneComponent.data}
              dataSourceStr={this.props.dataSourceStr}
              navigationBarHeight={this.props.navigationBarHeight + tabBarHeight - 0.5}
              navigationBarPaddingTop={this.props.navigationBarPaddingTop}
              routeParams={this.props.routeParams}
              webpSupport={this.props.webpSupport}
              backgroundColor={this.props.backgroundColor}
              templateName={this.props.templateName}
              allModals={this.props.allModals}
              templatePti={this.props.templatePti}
              tabChName={this.state.tabChName || grains[tabIndex].tabTitle.tabName}
              legoAb={this.props.legoAb}
              tabIndex={tabIndex}
              tabActive={selected}
              tabFixed={tabFixed}
              componentSize={componentSize}
              tabContainerBgColor={grains[selected].tabTitle.tabContainerBgColor}
              reRender={reRender}
              lotteryState={this.props.lotteryState}
              communityVoteState={this.props.communityVoteState}
              updateLotteryState={this.props.updateLotteryState}
              updateCommunityVoteState={this.props.updateCommunityVoteState}
              {...otherProps}
              exp={(ele) => {
                if (ele) {
                  this.props.exp && this.props.exp(ele);
                }
              }}
            />
          </div>
        );
      });
      tabItemComponent.push(Components)
    }
    let tabItemClass = "tab-item", tabScroller = false, adaptive = false;
    if (!isAndroid && (osVersion == '15.1' || osVersion == '15.2')) {
      adaptive = true
    }
    tabItemClass += tabType === "文字Tab" ? ' type-text' : ' type-img';
    adaptive && (tabItemClass += tabFixed ? ' fixed' : '');
    if (tabType === "文字Tab") {
      if (grains.length >= 4) {
        tabItemClass += ' scroller';
        tabScroller = true;
      }
    } else {
      if (grains.length > 4) {
        tabItemClass += ' scroller';
        tabScroller = true;
      }
    }
    // 计算tabItem区域的最小高度
    let contentHeight = screenHeight;
    const pipelineTab = document.querySelector('.pipeline-tab');
    const tabScroll =  document.querySelector('.tab-scroll');
    const navigationBarWrapper = document.querySelector('.navigation-bar-wrapper');
    if (navigationBarWrapper) {
      contentHeight = contentHeight - navigationBarWrapper.clientHeight;
    }
    if (pipelineTab && tabScroll) {
      contentHeight = contentHeight - pipelineTab.offsetTop - tabScroll.clientHeight;
    }
    return (
      <div
        ref={ref => this.pipelineTabRef = ref}
        className={`pipeline-tab ${tabType === '文字Tab' ? 'text-type' : 'img-type'}`}
        {...this.props['customAttributes']}
        style={{
          marginTop: `${moduleMarginTop}px`,
        }}
      >
        {
          adaptive ? (
            tabFixed && <div ref={ref => this.tabItemPlaceholderRef = ref} className="placeholder tab-item-placeholder" style={{height: tabBarHeight}}></div>
          ) : (
            <div ref={ref => this.tabItemPlaceholderRef = ref}  className="placeholder tab-item-placeholder"></div>
          )
        }
        <div
          ref={ref => this.tabItemRef = ref}
          className={`${tabItemClass} tab-nav`}
          style={{
            top: this.props.navigationBarHeight,
            backgroundColor: this.props.backgroundColor
          }}
        >
          <ul className={tabScroller ? 'tab-scroll custom-padding' : 'tab-scroll'}>
            {
              grains.map((item, index) => {
                let tabNavClass = "";
                tabNavClass = selected == index ? 'tab-item-nav tab-item-nav-active active' : 'tab-item-nav';
                tabNavClass += tabScroller ? ' customWidth' : ' autoWidth'
                console.log('item', item)
                return (
                  <li
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, {
                      sort: index
                    }))}
                    className={tabNavClass}
                    key={`tab-item-nav-${index}`}
                    onClick={(event) => this.handleTabSelect(event, item, index)}
                  >
                    {
                      tabType !== '文字Tab' 
                        ? <img src={selected == index ? item.tabTitle.selectedImg : item.tabTitle.unselectedImg} />
                        : <p 
                            style={{
                              color: selected == index ? fontColor : fontColor,
                              opacity: selected == index ? 1 : .7,
                            }}
                          >
                            {item.tabTitle.tabName}
                          </p>
                    }
                    {selected === index && <p className="underline" style={{backgroundColor: fontColor}}></p>}
                  </li>
                )
              })
            }
          </ul>
        </div>
        <div ref={ref => this.tabItemContentRef = ref} className="tab-item-content tab-content" style={{ backgroundColor: grains[selected].tabTitle.tabContainerBgColor, minHeight: (findIndexPipelineTab === pipelineFilterTabItem.length - 1) ? contentHeight : 'auto'}}>
          {
            tabItemComponent.map((item, index) => {
              const hasRecord = selectRecord.findIndex(item => item === index)
              if (hasRecord >= 0) {
                return (
                  <div
                    data-component-id={pipelineTabItem[index] && pipelineTabItem[index]['id']}
                    data-component-name={pipelineTabItem[index] && pipelineTabItem[index]['name']}
                    key={`tab-container-${index}`}
                    className={selected == index ? `tab-container ${this.isIframe ? 'iframe' : 'app'} show` : `tab-container ${this.isIframe ? 'iframe' : 'app'} hide`}
                  >
                    {item}
                  </div>
                ) 
              } else {
                return (
                  <div
                    data-component-id={pipelineTabItem[index] && pipelineTabItem[index]['id']}
                    data-component-name={pipelineTabItem[index] && pipelineTabItem[index]['name']}
                    key={`tab-container-${index}`}
                    className={selected == index ? `tab-container ${this.isIframe ? 'iframe' : 'app'} show` : `tab-container ${this.isIframe ? 'iframe' : 'app'} hide`}
                  >
                    { this.isIframe ? item : null }
                  </div>
                )
              }
            })
          }
        </div>
      </div>
    );
  }
}

PipelineTab.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineTab };
export default PipelineTab;



// WEBPACK FOOTER //
// ./components/pipeline-tab/index.js